module.exports = __webpack_public_path__ + "media/images/proof_links/qq-e645ab13245482f50dcef1550c6f118e.svg";